module.exports = __webpack_public_path__ + "static/img/element_04.d5c74d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/element_04.png
// module id = yZ6z
// module chunks = 24